import { TKV2_PUBLIC_RECORD_API } from '@aloft/toolkit-shared';
import { UseQueryOptions, UseQueryResult, useQuery } from '@tanstack/react-query';

import { z } from 'zod';

import {
  GetTkv2PublicRecordAPIError,
  GetTkv2PublicRecordAPIVariables,
  fetchGetTkv2PublicRecordAPI,
} from '../toolkitComponents.ts';
import { queryKeyFn, useToolkitContext } from '../toolkitContext.ts';

const API_SCHEMA = TKV2_PUBLIC_RECORD_API.GET;

export const useGetTkv2PublicRecordAPI = (
  variables: GetTkv2PublicRecordAPIVariables,
  opts?: Omit<
    UseQueryOptions<z.infer<typeof API_SCHEMA.RESPONSE>, GetTkv2PublicRecordAPIError>,
    'queryKey' | 'queryFn'
  >,
): UseQueryResult<z.infer<typeof API_SCHEMA.RESPONSE>, GetTkv2PublicRecordAPIError> => {
  const { fetcherOptions } = useToolkitContext();

  return useQuery<z.infer<typeof API_SCHEMA.RESPONSE>, GetTkv2PublicRecordAPIError>({
    queryKey: queryKeyFn({
      path: '/api/v2/orders/{orderID}/publicRecord',
      operationId: 'getTkv2PublicRecordAPI',
      variables,
    }),
    queryFn: async () => {
      const res = await fetchGetTkv2PublicRecordAPI({ ...fetcherOptions, ...variables });
      return API_SCHEMA.RESPONSE.parse(res);
    },
    ...opts,
  });
};
